import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import { ApiBaseService } from '../crud.service';

@Injectable()
export class SwapsService extends ApiBaseService {
    constructor(protected httpClient: HttpClient) {
        super(httpClient, '/service/metatrader/upload_swap_rate');
    }

    post(file: any): Observable<any> {
        return this.httpClient.post(this.basePath, file,
            {headers: {'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}});
    }
}
